<template>
  <div class="orangehrm-background-container">
    <div class="orangehrm-card-container">
      <oxd-text tag="h6" class="orangehrm-main-title">
        {{ $t('admin.edit_company_rules') }}
      </oxd-text>

      <oxd-divider />

      <oxd-form :loading="isLoading" @submit-valid="onSave">
        <oxd-form-row>
          <oxd-input-field
            v-model="companyRules.description"
            type="textarea"
            :label="$t('general.description')"
            :rules="rules.description"
            required
          />
        </oxd-form-row>
        <oxd-form-row>
          <file-upload-input
            v-model:newFile="companyRules.attachmentNew"
            v-model:method="companyRules.method"
            :label="$t('dashboard.company_rules_pdf')"
            :button-label="$t('general.browse')"
            :file="companyRules.attachment"
            :rules="rules.attachment"
            :url="companyRules.downloadPath"
            :hint="$t('general.accepts_up_to_1mb')"
            :deletable="false"
            :accept="acceptFile"
          />
        </oxd-form-row>

        <oxd-divider />

        <oxd-form-actions>
          <required-text />
          <oxd-button
            display-type="ghost"
            :label="$t('general.cancel')"
            @click="onCancel"
          />
          <submit-button />
        </oxd-form-actions>
      </oxd-form>
    </div>
  </div>
</template>

<script>
import {navigate} from '@ohrm/core/util/helper/navigation';
import {APIService} from '@/core/util/services/api.service';
import {
  required,
  validFileTypes,
  maxFileSize,
} from '@ohrm/core/util/validation/rules';
import FileUploadInput from '@/core/components/inputs/FileUploadInput.vue';

const initialData = {
  description: '',
  attachment: {
    id: null,
    filename: '',
    filetype: '',
    size: '',
  },
  attachmentNew: {
    id: null,
    name: '',
    type: '',
    size: '',
    base64: '',
  },
  downloadPath: '',
  method: 'keepCurrent',
};

export default {
  components: {
    'file-upload-input': FileUploadInput,
  },
  props: {
    allowedFileTypes: {
      type: Array,
      required: true,
    },
    maxFileSize: {
      type: Number,
      required: true,
    },
    companyRulesId: {
      type: Number,
      required: true,
    },
  },

  setup() {
    const http = new APIService(
      window.appGlobal.baseUrl,
      '/api/v2/admin/company-rules',
    );
    return {
      http,
    };
  },

  data() {
    return {
      isLoading: false,
      companyRules: {...initialData},
      rules: {
        description: [required],
        attachment: [
          required,
          validFileTypes(this.allowedFileTypes),
          maxFileSize(this.maxFileSize),
        ],
      },
      acceptFile: '*/*',
    };
  },

  created() {
    this.isLoading = true;
    this.http
      .get(this.companyRulesId)
      .then((response) => {
        const {data} = response.data;
        this.companyRules.description = data.description;
        this.companyRules.attachment.id = data.id;
        this.companyRules.attachment.filename = data.filename;
        this.companyRules.attachment.filetype = data.fileType;
        this.companyRules.attachment.size = data.size;
        this.companyRules.downloadPath = `dashboard/viewCompanyRules/id`;
      })
      .finally(() => {
        this.isLoading = false;
      });
  },

  methods: {
    onCancel() {
      navigate('/admin/companyRules');
    },
    onSave() {
      this.isLoading = true;
      this.http
        .update(this.companyRulesId, {
          description: this.companyRules.description,
          ...(this.companyRules.attachmentNew?.name && {
            attachment: this.companyRules.attachmentNew,
          }),
        })
        .then(() => {
          return this.$toast.saveSuccess();
        })
        .then(() => {
          this.onCancel();
        })
        .finally(() => {
          this.isLoading = false;
        });
    },
  },
};
</script>
